export enum Envirenment {
  production,
  avd,
  development,
}
// export const productionMode =Envirenment.avd as Envirenment
export const productionMode =
  process.env['NODE_ENV'] == 'production'
    ? Envirenment.production
    : process.env['NODE_ENV'] == 'avd'
    ? Envirenment.avd
    : Envirenment.development;
export const apiUrl = `https://trulov.api.trusom.com`;
// export const apiUrl = `http://localhost:3000`
